// extracted by mini-css-extract-plugin
export var dot = "PillGrid-module--dot--09511";
export var pill = "PillGrid-module--pill--625e1";
export var pills = "PillGrid-module--pills--d4132";